import { PStyled } from 'approot/shared/styles/typography.style';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from '../activity-builder-drawer';
import { useActivityBuilderContext } from '../activity-builder.context';
import { SettingsDrawerEmptyState } from './settings-drawer.style';

import emptyImage from './component-select-slide.png';

const SettingsDrawerColumnComponent = () => {
  const { closeDrawer } = useActivityBuilderContext();

  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader
        title=""
        hasBorderBottom={false}
        onClose={closeDrawer}
      />
      <ActivityBuilderDrawerContent>
        <SettingsDrawerEmptyState>
          <img src={emptyImage} alt="" />
          <PStyled textAlignCenter>
            You have selected the Column component. Use the inline controls to
            manage column styles.
          </PStyled>
        </SettingsDrawerEmptyState>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default SettingsDrawerColumnComponent;
